import { Link } from "react-router-dom";

/**
 * Shared dark footer used on every page.
 */
export function Footer() {
  return (
    <footer
      className="site-footer py-14 sm:py-16"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 text-center">
        <img
          src="/brand/supple-logo-transparent.png"
          alt="Supple"
          className="h-12 sm:h-14 w-auto mx-auto"
          data-testid="footer-logo"
        />

        <nav className="mt-6 flex items-center justify-center gap-6 flex-wrap">
          <Link
            to="/why"
          className="site-footer__link text-sm font-medium"
            data-testid="footer-why-link"
          >
            Why Supple
          </Link>
          <Link
            to="/journal"
          className="site-footer__link text-sm font-medium"
            data-testid="footer-journal-link"
          >
            Journal
          </Link>
          <a
            href="/questions"
            onClick={(e) => {
              e.preventDefault();
              window.location.assign("/questions");
            }}
          className="site-footer__link text-sm font-medium"
            data-testid="footer-questions-link"
          >
            Questions
          </a>
          <Link
            to="/#waitlist"
          className="site-footer__link text-sm font-medium"
            data-testid="footer-waitlist-link"
          >
            Waitlist
          </Link>
        </nav>

        <p className="mt-8 font-display italic site-footer__headline text-lg sm:text-xl">
          Built for women whose bodies aren&apos;t in the literature yet.
        </p>
        <p className="mt-6 text-sm site-footer__body max-w-xl mx-auto leading-relaxed">
          Educational guidance, not medical diagnosis. Always consult a
          clinician for medical decisions.
        </p>
        <p className="mt-8 text-xs tracking-[0.2em] uppercase site-footer__meta">
          © 2026 Supple · All rights reserved
        </p>
      </div>
    </footer>
  );
}
